import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, Sparkles } from 'lucide-react';

export default function AssessmentCard({ assessment }) {
  const navigate = useNavigate();
  const toneMap = {
    indigo: 'from-indigo-500/20 to-indigo-600/8 text-indigo-700 border-indigo-200/60',
    blue: 'from-sky-500/20 to-blue-600/8 text-blue-700 border-blue-200/60',
    green: 'from-emerald-500/20 to-emerald-600/8 text-emerald-700 border-emerald-200/60',
    amber: 'from-amber-500/20 to-amber-600/8 text-amber-700 border-amber-200/60',
    purple: 'from-purple-500/20 to-purple-600/8 text-purple-700 border-purple-200/60'
  };
  const tone = toneMap[assessment.color] || toneMap.indigo;

  return (
    <button
      type="button"
      onClick={() => navigate(assessment.route)}
      className="glass-elevated group text-left p-6 w-full rounded-2xl transition-smooth hover:-translate-y-1"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className={`inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br ${tone}`}>
            <Sparkles className="w-5 h-5" />
          </span>
          <h3 className="text-lg font-semibold text-slate-900">{assessment.label}</h3>
        </div>
        {assessment.badge ? (
          <span className="text-xs font-semibold px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 border border-indigo-200/70">
            {assessment.badge}
          </span>
        ) : null}
      </div>
      <p className="text-sm text-slate-500 mt-2">{assessment.subtitle}</p>
      <p className="text-sm text-slate-700 mt-3 leading-relaxed">{assessment.description}</p>
      <div className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-indigo-700 group-hover:text-indigo-800">
        Start Assessment
        <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </button>
  );
}
